import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#050505' }}>
      <div className="max-w-md w-full p-8 rounded-xl" style={{ background: '#121212', border: '1px solid #2A2A2A' }}>
        <div className="text-center">
          <XCircle className="w-16 h-16 text-[#EE1C4E] mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h1>
          <p className="text-gray-400 mb-6">
            Your subscription payment was cancelled. No charges have been made.
          </p>
          
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/profile')}
              className="w-full bg-[#EE1C4E] hover:bg-[#D91744] text-white"
            >
              Back to Profile
            </Button>
            <Button
              onClick={() => navigate('/feed/home')}
              variant="outline"
              className="w-full bg-transparent border-gray-700 text-white hover:bg-[#1A1A1A]"
            >
              Browse Content
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
